import { styled } from '@material-ui/core/styles';

export const GridTitleFilterListStyled = styled('div')({
    paddingTop: 10,
    // marginLeft: 12,
    // marginRight: 12,
});
